<template>
  <div>
    <UtilityBar
      :shouldToggle="true"
      @getHolidays="manageGetHolidays"
      :userFilter="true"
    />

    <HolidayTable :tableHeader="tableHeader" />

    <ActionModal @closeModal="closeModal2" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BButton,
  BFormGroup,
  BCard,
  BCardHeader,
  BCardBody,
} from 'bootstrap-vue'

//import LeadTable from './components/table'
import LeadTable from '../../components/table'
import VueElementLoading from 'vue-element-loading'
import ActionModal from '../../components/modal'
import UtilityBar from './components/utilityBar'
import HolidayTable from './components/table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import swal from 'sweetalert2'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    LeadTable,
    VueElementLoading,
    ActionModal,
    UtilityBar,
    HolidayTable,
  },
  data() {
    return {
      userData: getUserData(),
      tableHeader: [
        {
          key: 'isAllDay',
          label: 'Vigencia',
          thStyle: { width: '5%' },
        },
        {
          key: 'dates',
          label: 'Inicio/Final',
          thStyle: { width: '25%' },
        },
        {
          key: 'initialTime',
          label: 'Inicio',
          thStyle: { width: '10%' },
        },
        {
          key: 'lunchTime',
          label: 'Almuerzo',
          thStyle: { width: '10%' },
        },
        {
          key: 'finalTime',
          label: 'Cierre',
          thStyle: { width: '10%' },
        },
        {
          key: 'capacity',
          label: 'Capacidad',
          thStyle: { width: '10%' },
        },
        {
          key: 'action',
          label: 'Acción',
          thStyle: { width: '5%' },
        }
      ],
    }
  },
  computed: {
    ...mapState('holidays', ['holidays']),
  },
  methods: {
    closeModal2() {
      this.toggleValidation(false)
      this.toggleModal({ value: false, type: null })
    },
    manageGetHolidays() {
      this.getHolidays().then((response) => {
        //this.setOptions(response.data.options)
      })
    },
    ...mapActions('holidays', ['getHolidays']),
    ...mapMutations('locations', [
      'setActionType',
      'deleteAssignedLead',
      'toggleModal',
      'toggleValidation',
    ]),
    ...mapMutations('tableFilters', ['setOptions']),
  },
  created() {
    this.setActionType('get-leads')
    this.manageGetHolidays()
  },
}
</script>
